import { shoppingCarChange } from 'app_events/app/actions';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useSyncShoppingCart = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const syncCart = (event: StorageEvent) => {
      if (event.key === "shoppingCart") {
        const updatedCart = JSON.parse(event.newValue || "[]");
        dispatch(shoppingCarChange(updatedCart)); // Actualizar Redux con el nuevo carrito
      }
    };

    window.addEventListener("storage", syncCart);
    return () => window.removeEventListener("storage", syncCart);
  }, [dispatch]);
}


// export const useShoppingCartLastAction = () => {
//   const key = 'shoppingCartLastAction'
//   const [value, setValue] = useState(() => localStorage.getItem(key));

//   useEffect(() => {
//     const handleStorageChange = (event: StorageEvent) => {
//       // console.log('handleStorageChange', event)
//       if (event.key === key) {
//         console.log('value', value)
//         // setValue(JSON.parse(event.newValue || '')); // Actualiza el estado con el nuevo valor
//       }
//     };

//     window.addEventListener("storage", handleStorageChange);
//     return () => window.removeEventListener("storage", handleStorageChange);
//   }, [key]);

//   return value;
// }
